import React from 'react';

const Preloader = () => (
  <div className="main-preloader">
    <div className="preloader" />
  </div>
);

export default Preloader;
